import service from "./auth";

export function getUserList(param) {
    return service({
        method: 'get',
        url: '/user/list',
        params: param
    })
}

export function getUserDetail(param) {
    return service({
        method: 'get',
        url: '/user/detail',
        params: param
    })
}

export function getUserCreditsDetail(param) {
    return service({
        method: 'get',
        url: '/user/creditsdetail',
        params: param
    })
}


export function getUserInfo(param) {
    return service({
        method: 'get',
        url: '/user/info',
        params: param
    })
}

export function updateUserInfo(param, data) {
    return service({
        method: 'post',
        url: '/user/update',
        params: param,
        data: data
    })
}

export function rechargeUserCard(data) {
    return service({
        method: 'post',
        url: '/user/recharge',
        data
    })
}

export function queryUser(param) {
    return service({
        method: 'get',
        url: '/user/kwquery',
        params: param
    })
}
